var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-774.000000, -1501.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(736.000000, 1316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333333,12.1904762 C15.8590476,12.1904762 16.2857143,12.6000762 16.2857143,13.1047619 C16.2857143,13.5619048 16.0152381,13.7817905 15.8095238,13.8974476 C15.2452381,14.2142476 13.4285714,14.9333333 13.4285714,14.9333333 L13.4285714,14.9333333 L15.452381,17.4192762 C15.452381,17.4192762 15.8095238,17.8467048 15.8095238,18.1333333 C15.8095238,18.638019 15.3828571,19.047619 14.8571429,19.047619 C14.3709524,19.047619 14.1504762,18.7477333 14.1504762,18.7477333 C14.1504762,18.7477333 12.0033333,16.3015619 12,16.3047619 C11.9966667,16.3015619 9.84952381,18.7477333 9.84952381,18.7477333 C9.84952381,18.7477333 9.62904762,19.047619 9.14285714,19.047619 C8.61714286,19.047619 8.19047619,18.638019 8.19047619,18.1333333 C8.19047619,17.8467048 8.54761905,17.4192762 8.54761905,17.4192762 L8.54761905,17.4192762 L10.5714286,14.9333333 C10.5714286,14.9333333 8.7547619,14.2142476 8.19047619,13.8974476 C7.9847619,13.7817905 7.71428571,13.5619048 7.71428571,13.1047619 C7.71428571,12.6000762 8.14095238,12.1904762 8.66666667,12.1904762 C9.14285714,12.1904762 10.0952381,13.1047619 12,13.1047619 C13.9047619,13.1047619 14.8571429,12.1904762 15.3333333,12.1904762 Z M12,5.33333333 C13.8404762,5.33333333 15.3333333,6.76601905 15.3333333,8.53333333 C15.3333333,10.3006476 13.8404762,11.7333333 12,11.7333333 C10.1590476,11.7333333 8.66666667,10.3006476 8.66666667,8.53333333 C8.66666667,6.76601905 10.1590476,5.33333333 12,5.33333333 Z M12,6.93333333 C11.0795238,6.93333333 10.3333333,7.64967619 10.3333333,8.53333333 C10.3333333,9.41744762 11.0795238,10.1333333 12,10.1333333 C12.92,10.1333333 13.6666667,9.41744762 13.6666667,8.53333333 C13.6666667,7.64967619 12.92,6.93333333 12,6.93333333 Z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default ForwardRef;